const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  UPDATA_PROFILE_REQUEST: 'UPDATA_PROFILE_REQUEST',
  UPDATA_PROFILE_SUCCESS: 'UPDATA_PROFILE_SUCCESS',
  UPDATA_PROFILE_FAILURE: 'UPDATA_PROFILE_FAILURE',
  UPDATA_PROFILE_PICTURE_REQUEST: 'UPDATA_PROFILE_PICTURE_REQUEST',
  UPDATA_PROFILE_PICTURE_SUCCESS: 'UPDATA_PROFILE_PICTURE_SUCCESS',
  UPDATA_PROFILE_PICTURE_FAILURE: 'UPDATA_PROFILE_PICTURE_FAILURE',
  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',
  CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',
  GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE: 'GET_PROFILE_FAILURE',
  REFRESH_TOKENT_REQUEST: 'REFRESH_TOKENT_REQUEST',
  REFRESH_TOKENT_SUCCESS: 'REFRESH_TOKENT_SUCCESS',
  REFRESH_TOKENT_FAILURE: 'REFRESH_TOKENT_FAILURE',
  LOGOUT: 'USERS_LOGOUT',
  // messages
  USER_UNVERIFIED_MESSAGE:
    'Please verify your email address to access the appliction',
  EXPIRED_TOKEN: 'Unauthorized: Expired token',
};

export default userConstants;
